import Model from '@/store/plugins/orm/Model'
import { Table } from './ModelRepository'

export class Sector extends Model {
    static get entity() {
        return 'sectors';
    }

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            image: this.attr(null),
            image_url: this.attr(null),

            tables: this.hasMany(Table, 'sector_id')
        };
    }
}

export default Sector
